// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Q3-z","colorTextValue":"R3-z","swatches":"S3-z","collapseLink":"T3-z","isCollapsed":"U3-z","dropdown":"V3-z","disabled":"W3-z"};